import m from "../../geodata/es2015/worldIndiaHigh";
window.am4geodata_worldIndiaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/worldIndiaHigh.js
// module id = null
// module chunks = 